export default __webpack_public_path__ + "static/media/h3.1ed2f577.jpeg";